import Vue from 'vue'
import Router from 'vue-router'
import config from '@/config.js'
Vue.use(Router)

import login from '@/components/login'
import index from '@/components/index'
import HelloWorld from '@/components/HelloWorld'
import SDL from '@/components/SDL'
import table from '@/components/table'
import NProgress from 'nprogress'
import pageOne from '@/api/pageOne/pageOne.vue'
import pageOneList from '@/api/pageOne/pageOneList.vue'
import pageTwo from '@/api/pageTwo/pageTwo.vue'
import { path } from 'chromedriver'

/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 */
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location, onResolve, onReject) {
//   location.path = config.RoutePrefix + location.path;
//   //  console.log(location)
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this,location).catch((err) => err);
// };


export default new Router({
  routes: [
    {
      path: '/login', 
      name: 'Login',
      component: login,
      meta: {
        keepAlive: true,
        requireAuth: true, // 判断是否需要登录
       }
    },
    {
      path: '/',
      name: 'Home',
      component: index
    },
    {
      path: '/pageOne',
      name: 'pageOne',
      component: pageOne
    },
    {
      path: '/pageOneList',
      name: 'pageOneList',
      component: pageOneList
    },
    {
      path: '/pageTwo',
      name: 'pageTwo',
      component: pageTwo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js